import $ from 'jquery'

export const loadCSS = function (href, id) {
    // console.log("called CSS Import")
    var cssLink = $("<link>");
    $("head").append(cssLink); //IE hack: append before setting href

    cssLink.attr({
        rel: "stylesheet",
        type: "text/css",
        key: id,
        href: href
    });
};

export const loadAndCacheCSS = async (href, key) => {
    let current_hotel_code = (
        localStorage.getItem("clientId") ||
        sessionStorage.getItem("clientId") ||
        process.env.REACT_APP_CLIENT_CONFIG ||
        ""
    ).replace("GJ_", "").toUpperCase();

    let isCordovaIOS = false;
    try {
        isCordovaIOS = window && window.cordova && window.cordova.platformId === "ios";
    } catch (e) {
        isCordovaIOS = false;
    }

    // ✅ Bypass only for iOS app and hotel USMIAVC
    if (current_hotel_code === "USMIAVC" && isCordovaIOS) {
        loadCSS(href, key);
        console.log(`[loadAndCacheCSS] Bypassing cache for hotel ${current_hotel_code} on Cordova iOS`);
        return;
    }

    const injectStyle = (css) => {
        const existingTags = document.querySelectorAll('style[data-dynamic-css]');
        existingTags.forEach(tag => tag.remove());

        const styleTag = document.createElement("style");
        styleTag.innerText = css;
        styleTag.setAttribute("data-dynamic-css", "true"); 
        styleTag.setAttribute("data-key", key);
        document.head.appendChild(styleTag);
    };

    try {
        const response = await fetch(href);
        if (!response.ok) throw new Error("Failed to fetch CSS");

        const cssText = await response.text();
        injectStyle(cssText);
        localStorage.setItem(`Cached_Dynamic_CSS_${current_hotel_code}`, cssText);
        console.log(`[loadAndCacheCSS] Loaded from network and cached: ${key}`);
    } catch (error) {
        console.warn(`[loadAndCacheCSS] Network failed, checking cache: ${key}`, error);
        const cachedCSS = localStorage.getItem(`Cached_Dynamic_CSS_${current_hotel_code}`);
        if (cachedCSS) {
            injectStyle(cachedCSS);
            console.log(`[loadAndCacheCSS] Loaded from localStorage cache: ${key}`);
        } else {
            console.error(`[loadAndCacheCSS] No cached CSS available for: ${key}`);
        }
    }
};



export const cssSelector = (loadKey) => {
    if (loadKey) {
        loadCSS("layout_1/default.css")
        loadCSS("layout_1/theme.css")
        loadCSS("layout_1/default_theme.css")
        loadCSS("layout_1/bootstrap.css")
    } else {
        loadCSS("layout_2/default.css")
        loadCSS("layout_2/theme/theme.css")
    }
}